module.exports = __webpack_public_path__ + "img/building-columns.558b13e7.svg";